import s from "./Footer.module.scss";

const Footer = () => {

    return (
        <footer>
            <img src="/assets/logoLabelDEC.png" alt="L'association a obtenu le label Don en confiance" />
            <nav className={s.links}>
                <ul>
                    <li><a href="https://www.avh.asso.fr/" target="_blank">Site de l'association</a></li>
                    <li><a href="https://www.avh.asso.fr/espace-presse" target="_blank">Espace presse</a></li>
                </ul>
            </nav>
            <nav className={s.social}>
                <ul >
                    <li><a href="https://www.facebook.com/AssociationValentinHauy/" target="_blank"><img src="/assets/logoFb.png" alt="Lien vers le compte Facebook de l'association" /></a></li>
                    <li><a href="https://x.com/ValentinHauy" target="_blank"><img src="/assets/logoX.png" alt="Lien vers le compte X, anciennement Twitter, de l'association" /></a></li>
                    <li><a href="https://www.instagram.com/associationvalentinhauy/" target="_blank"><img src="/assets/logoInsta.png" alt="Lien vers le compte Instagram de l'association" /></a></li>
                    <li><a href="https://www.youtube.com/user/AssoValentinHauy" target="_blank"><img src="/assets/logoYtb.png" alt="Lien vers la chaine Youtube de l'association" /></a></li>
                    <li><a href="https://www.linkedin.com/company/association-valentin-hauy/" target="_blank"><img src="/assets/logoLkd.png" alt="Lien vers le compte LinkedIn de l'association" /></a></li>
                </ul>
           </nav>
        </footer>
    )
};

export default Footer;